import React, { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import { navigationRef } from '../../App';
import { useGradeGateContext } from '../contexts/GradeGateContext';
import { useReviewGateContext } from '../contexts/ReviewGateContext';
import GradeGateOverlay from './GradeGateOverlay';
import GateUnavailableOverlay from './GateUnavailableOverlay';

const GlobalGradeGate = () => {
  const {
    isGated,
    submittedCount,
    requiredCount,
    setExempt,
    loading,
    status,
    retry,
    currentSemester,
  } = useGradeGateContext();
  const { isGated: isReviewGated, status: reviewStatus } = useReviewGateContext();
  const [currentRoute, setCurrentRoute] = useState<string | undefined>(undefined);
  const [currentRouteParams, setCurrentRouteParams] = useState<any>(undefined);

  useEffect(() => {
    if (!navigationRef.isReady()) return;

    const route = navigationRef.getCurrentRoute();
    setCurrentRoute(route?.name);
    setCurrentRouteParams(route?.params);

    const unsubscribe = navigationRef.addListener('state', () => {
      const current = navigationRef.getCurrentRoute();
      setCurrentRoute(current?.name);
      setCurrentRouteParams(current?.params);
    });

    return unsubscribe;
  }, []);

  const isRecoveryModeRoute =
    (currentRoute === 'Courses' && currentRouteParams?.recoveryMode === true) ||
    (currentRouteParams?.screen === 'Courses' && currentRouteParams?.params?.recoveryMode === true);

  const handleGoToRecovery = () => {
    if (navigationRef.isReady()) {
      // @ts-ignore
      navigationRef.navigate('TabRoot', {
        screen: 'Courses',
        params: {
          recoveryMode: true,
          recoveryType: 'grade',
          recoveryOrigin: 'unavailable',
          lockedAcademicYear: currentSemester.academicYear,
          lockedSemester: currentSemester.semester,
        },
      });
    }
  };

  const exemptRoutes = ['Schedule', 'GradeSubmit', 'CourseReviewForm', 'ReviewManagement', 'Settings', 'CalendarExport'];
  if (currentRoute && exemptRoutes.includes(currentRoute)) {
    return null;
  }

  if (isReviewGated || reviewStatus !== 'ready' || isRecoveryModeRoute) return null;

  const tabRoutes = ['Courses', 'SavedSchedules'];
  const isTabRoute = currentRoute && tabRoutes.includes(currentRoute);
  
  // タブバーが表示されている画面では、タブバーの上までを覆うようにする
  // iOS: bottom margin 20 + bottom 25 + height 80 = 125
  // Android/Web: height 60
  const bottomOffset = isTabRoute ? (Platform.OS === 'ios' ? 125 : 60) : 0;

  if (status !== 'ready' && isGated) {
    return (
      <GateUnavailableOverlay
        visible={true}
        loading={status === 'loading'}
        onRetry={() => { void retry(); }}
        onGoToRecovery={handleGoToRecovery}
        bottomOffset={bottomOffset}
      />
    );
  }

  if (!isGated) return null;

  const handleGoToGrade = () => {
    if (navigationRef.isReady()) {
      // @ts-ignore
      navigationRef.navigate('ReviewManagement');
    }
  };

  const handleGoToGatedRecovery = () => {
    if (navigationRef.isReady()) {
      // @ts-ignore
      navigationRef.navigate('TabRoot', {
        screen: 'Courses',
        params: {
          recoveryMode: true,
          recoveryType: 'grade',
          lockedAcademicYear: currentSemester.academicYear,
          lockedSemester: currentSemester.semester,
        },
      });
    }
  };

  return (
    <GradeGateOverlay
      visible={true}
      submittedCount={submittedCount}
      requiredCount={requiredCount}
      onGoToGrade={handleGoToGrade}
      onGoToRecovery={handleGoToGatedRecovery}
      onExempt={setExempt}
      loading={loading}
      bottomOffset={bottomOffset}
    />
  );
};

export default GlobalGradeGate;
